import React from 'react';
import { useQuery } from '@tanstack/react-query';

import { userApi } from '../../services/api';
import { logger } from '../../services/logger';
import { Avatar } from './Avatar';

export interface UserAvatarProps {
  userId: string | number;
  width?: number;
  height?: number;
}

export function UserAvatar({
  userId,
  width = 24,
  height = width,
}: UserAvatarProps) {
  const { data, isPending } = useQuery({
    queryKey: ['userAvatarQuery'],
    async queryFn(): Promise<
      Map<
        string,
        {
          name: string;
          image: string | null;
        }
      >
    > {
      try {
        const users = await userApi.getAll();

        return new Map(
          users.map((user) => [
            user.user_id,
            {
              name: user.username,
              image: user.image?.path || null,
            },
          ]),
        );
      } catch (error) {
        logger.error('Error loading users list', {
          error,
        });

        return new Map();
      }
    },
  });

  const userProps = data?.get(String(userId));

  return (
    <div style={{ width, height, display: 'inline-block' }}>
      <Avatar
        {...userProps}
        loading={isPending}
        width={width}
        height={height}
        round
      />
    </div>
  );
}
